import getProperServiceIcon from '../../../utils/getProperServiceIcon'
import validateRoute from '@/router/utils/validateRoute.js'
import acl from './acl'

export default function (service, name, workflow, client) {
// let workflowName = taskType.split('-').join('_')
// const routePrefix = `${service}_${client}_${workflowName}`
  let customBreadcrumbs = {
    taskListing: {
      meta: {
        icon:  getProperServiceIcon(service),
        title: name
      }
    }
  }
  customBreadcrumbs[`${service}_subtask_category`] = {
    name: `${service}_subtask_category`,
    meta: {
      icon: 'list',
      title: 'Podzlecenie',
      breadcrumb: {
        dynamicLabel: true,
      },
      acl: {security: false}
    }
  }

  return [
    {
      path: `zlecenia/:service/:client/:taskCategoryId`,
      name: `${service}_task_listing`,
      props: true,
      component: () => import(/* webpackChunkName: "custom-bwn-like-task-listing" */ `../../../../components/bundles/${service}/taskListing/Listing`),
      meta: {
        securityDynamic: true,
        title: name,
        breadcrumb: {
          dynamicLabel: true,
          list: [
            customBreadcrumbs.taskListing
          ]
        },
        icon: getProperServiceIcon(service),
      },
      beforeEnter: (to, from, next) => {
        let newTo = {...to, meta: {...to.meta, acl: acl(to)[to.name]}}
        validateRoute(newTo, from, next)
      }
    },
    {
      path: `zlecenia/:service/:client/:taskCategoryId/:id`,
      component: () => import(/* webpackChunkName: "custom-bwn-like-task-details" */ `../../../../components/bundles/${service}/MainTask/Details.vue`),
      props: true,
      name: `${service}_task_details`,
      meta: {
        securityDynamic: true,
        breadcrumb: {
          dynamicLabel: true,
          list: [
            customBreadcrumbs.taskListing,
            `${service}_task_listing`
          ]
        }
      },
      beforeEnter: (to, from, next) => {
        let newTo = {...to, meta: {...to.meta, acl: acl(to)[to.name]}}
        validateRoute(newTo, from, next)
      }
    },
    {
      path: `zlecenia/:service/:client/:taskCategoryId/:id/:appraisalTaskCategory/:appraisalTaskId`,
      component: () => import(/* webpackChunkName: "custom-bwn-like-appraisal-task-details" */ `../../../../components/bundles/${service}/appraisal/task/Details`),
      props: true,
      name: `${service}_appraisal_task_details`,
      meta: {
        securityDynamic: true,
        breadcrumb: {
          dynamicLabel: true,
          list: [
            customBreadcrumbs.taskListing,
            `${service}_task_listing`,
            `${service}_task_details`,
            customBreadcrumbs[`${service}_subtask_category`]
          ]
        },
        taskType: 'appraisal',
        title: 'Szczegóły zlecenia rzeczoznawczego'
      },
      beforeEnter: (to, from, next) => {
        let newTo = {...to, meta: {...to.meta, acl: acl(to)[to.name]}}
        validateRoute(newTo, from, next)
      }
    },
    {
      path: `zlecenia/:service/:client/:taskCategoryId/import-finansowy/zlecenie-rzeczoznawcze`,
      name: `${service}_finance_import_invoice_appraisal`,
      component: () => import('../../../../components/bundles/intmil/finance-import/InvoiceImportDetailsAppraisal'),
      meta: {
        securityDynamic: true,
        breadcrumb: {
          list: [
            customBreadcrumbs.taskListing,
            `${service}_task_listing`
          ]
        },
        title: 'Import danych finansowych',
      },
      beforeEnter: (to, from, next) => {
        let newTo = {...to, meta: {...to.meta, acl: acl(to)[to.name]}}
        validateRoute(newTo, from, next)
      }
    },
    {
      path: `zlecenia/:service/:client/:taskCategoryId/import-finansowy/zlecenie-glowne`,
      name: `${service}_finance_import_invoice_main`,
      component: () => import('../../../../components/bundles/intmil/finance-import/InvoiceImportDetailsMain'),
      meta: {
        securityDynamic: true,
        title: 'Import danych finansowych',
        breadcrumb: {
          list: [
            customBreadcrumbs.taskListing,
            `${service}_task_listing`
          ]
        },
      },
      beforeEnter: (to, from, next) => {
        let newTo = {...to, meta: {...to.meta, acl: acl(to)[to.name]}}
        validateRoute(newTo, from, next)
      }
    },
    {
      path: 'zlecenia/:service/:client/:taskCategoryId/import-finansowy/zlecenie-rzeczoznawcze/podsumowanie',
      name: `${service}_finance_import_invoice_appraisal_summary`,
      component: () => import('../../../../components/bundles/intmil/finance-import/InvoiceImportDetailsAppraisal'),
      meta: {
        securityDynamic: true,
        breadcrumb: {
          list: [
            customBreadcrumbs.taskListing,
            `${service}_task_listing`
          ]
        },
        title: 'Import danych finansowych - Podsumowanie',
      },
      beforeEnter: (to, from, next) => {
        let newTo = {...to, meta: {...to.meta, acl: acl(to)[to.name]}}
        validateRoute(newTo, from, next)
      }
    },
    {
      path: 'zlecenia/:service/:client/:taskCategoryId/import-finansowy/zlecenie-glowne/podsumowanie',
      name: `${service}_finance_import_invoice_main_summary`,
      component: () => import('../../../../components/bundles/intmil/finance-import/InvoiceImportDetailsMain'),
      meta: {
        securityDynamic: true,
        breadcrumb: {
          list: [
            customBreadcrumbs.taskListing,
            `${service}_task_listing`
          ]
        },
        title: 'Import danych finansowych - Podsumowanie',
      },
      beforeEnter: (to, from, next) => {
        let newTo = {...to, meta: {...to.meta, acl: acl(to)[to.name]}}
        validateRoute(newTo, from, next)
      }
    },
  ]
}
